import React from "react";
import { StyledList } from "../style/support.style";
import SupCard from "./SupCard.component";
import HelpCenterCard from "./HelpCenterCard";
import cardsArray from "../content/supportArticles";

const SupportCards = () => {
	const displayCards = () => {
		return cardsArray.map((card, index) => {
			return (
				<li key={index}>
					<SupCard card={card} />
				</li>
			);
		});
	};
	return (
		<StyledList>
			<li key="helpCenterCard">
				<HelpCenterCard />
			</li>
			{displayCards()}
		</StyledList>
	);
};
export default SupportCards;
